import {IParams as IParams_RecreateHistory} from "../dialog/recreate.history"
import {global} from "../../../appContext";
import {nsFa} from "../../fa/fn";
import {IDialogOptionsComponent} from "../../dialog/index";
import i = nsFa.i;
import import_nav_bar_leftHtml from './import-nav-bar-left.html?raw';

export const template = import_nav_bar_leftHtml;

interface IParams {
    onRecreateObjectsClick(): void
    getNumObjectsLabel(): string
}

export class viewModel {
    constructor(private params: IParams_RecreateHistory) {
    }
}